import { reportUserViewAll, reportAdminViewAll, reportAdminViewDetails, reportAdminClose, ticketUserCreate, reportUserCreate } from 'redux/actions';
import { useRedux } from 'hooks';
import { ReportNew, ReportStatus } from '../../../../types/support/supportReport';

export default function useTicket() {
    const { dispatch, appSelector } = useRedux();

    const { reportedObjectId, reportCreatedSuccess, loading, userAllReports, error, apiSuccess, adminAllReports, adminReportDetails, reportClosedSuccess } = appSelector((state) => ({
        apiSuccess: state.Report.apiSuccess,
        adminAllReports: state.Report.adminAllReports,
        error: state.Report.error,
        reportClosedSuccess: state.Report.reportClosedSuccess,
        reportCreatedSuccess: state.Report.reportCreatedSuccess,
        reportedObjectId: state.Report.reportedObjectId,
        loading: state.Report.loading,
        adminReportDetails: state.Report.adminReportDetails,
        userAllReports: state.Report.userAllReports,
    }));

    const userLoadAllReports = () => {
        dispatch(reportUserViewAll());
    };

    const adminLoadAllReports = () => {
        dispatch(reportAdminViewAll());
    };

    const adminLoadReportDetails = (id: string, type: string) => {
        dispatch(reportAdminViewDetails(id, type));
    };

    const adminSolveReport = (id: string, type: string) => {
        dispatch(reportAdminClose(id, type, ReportStatus.ACCEPTED));
    };

    const adminRejectReport = (id: string, type: string) => {
        dispatch(reportAdminClose(id, type, ReportStatus.REJECTED));
    };

    const onReportSubmit = (formData: ReportNew) => {
        dispatch(reportUserCreate(formData));
    };

    return {
        userAllReports,
        loading,
        apiSuccess,
        adminReportDetails,
        adminAllReports,
        reportClosedSuccess,
        reportCreatedSuccess,
        reportedObjectId,
        userLoadAllReports,
        adminLoadReportDetails,
        adminLoadAllReports,
        adminSolveReport,
        adminRejectReport,
        onReportSubmit,
    };
}
